import * as React from 'react';

import Slide from '@material-ui/core/Slide';

export class Transition extends React.Component {
  public render() {
    return <Slide direction="up" {...this.props} />;
  }
}
